import { useListReportsByEnterpriseQuery } from '@/graphql/generated';
import type { StandardEnum } from '@/graphql/generated';

export const useListReportsByEnterprise = (
  enterpriseId: string | undefined,
  standardName?: StandardEnum,
) => {
  const { data, loading } = useListReportsByEnterpriseQuery({
    variables: { enterpriseId: enterpriseId ? enterpriseId : '' },
    skip: !enterpriseId,
    fetchPolicy: 'cache-and-network',
  });

  const reports = standardName
    ? data?.reports?.filter((report) => report.standard === standardName)
    : data?.reports;

  return {
    loading,
    reports,
  };
};
